var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('Modal', {
    attrs: {
      "width": "900",
      "mask-closable": false,
      "title": _vm.titleTip.title
    },
    on: {
      "on-visiable-change": _vm.cancel
    },
    model: {
      value: _vm.visible,
      callback: function ($$v) {
        _vm.visible = $$v;
      },
      expression: "visible"
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 16
    }
  }, [_c('Col', {
    attrs: {
      "span": "12"
    }
  }, [_c('Tabs', {
    attrs: {
      "animated": false,
      "name": "org-user-tag"
    }
  }, [_c('TabPane', {
    attrs: {
      "tab": "org-user-tag",
      "name": "entry-org",
      "label": $t("gio3m94", "组织架构")
    }
  }, [_c('div', {
    staticClass: "h-[400px] rounded-[4px] overflow-y-auto p-[5px] border-solid border-[#DCDFE6] border-[1px]"
  }, [_c('Input', {
    staticClass: "w-full",
    attrs: {
      "placeholder": $t("7lr2i56", "请输入关键字"),
      "icon": "ios-search",
      "clearable": ""
    },
    model: {
      value: _vm.searchKeys,
      callback: function ($$v) {
        _vm.searchKeys = $$v;
      },
      expression: "searchKeys"
    }
  }), _c('Tree', {
    ref: "orgTreeRef",
    attrs: {
      "check-strictly": "",
      "data": _vm.filterTreeData,
      "render": _vm.renderContent,
      "multiple": ""
    },
    on: {
      "on-select-change": _vm.onCheckChangeOrgTree
    }
  })], 1)]), _vm.titleTip.showTag ? _c('TabPane', {
    attrs: {
      "tab": "org-user-tag",
      "name": "entry-tag",
      "label": $t("g6mu2", "岗位")
    }
  }, [_c('div', {
    staticClass: "h-[400px] rounded-[4px] overflow-y-auto p-[5px] border-solid border-[#DCDFE6] border-[1px]"
  }, [_c('Input', {
    staticClass: "w-full",
    attrs: {
      "placeholder": $t("7lr2i56", "请输入关键字"),
      "icon": "ios-search"
    },
    model: {
      value: _vm.searchKeys,
      callback: function ($$v) {
        _vm.searchKeys = $$v;
      },
      expression: "searchKeys"
    }
  }), _c('Tree', {
    ref: "tagTreeRef",
    attrs: {
      "check-strictly": "",
      "data": _vm.filterTagData,
      "render": _vm.renderContent,
      "multiple": ""
    },
    on: {
      "on-select-change": _vm.onCheckChangeOrgTree
    }
  })], 1)]) : _vm._e()], 1)], 1), _c('Col', {
    attrs: {
      "span": "12"
    }
  }, [_c('div', {
    staticClass: "min-h-[37px] flex items-start mb-[16px] whitespace-normal word-wrap break-word"
  }, [_vm._v(" " + _vm._s(_vm.titleTip.tip) + " ")]), _c('div', {
    staticClass: "h-[400px] rounded-sm overflow-y-auto border-solid border-[#DCDFE6] border-[1px] p-[5px] flex flex-col"
  }, [_c('div', {
    staticClass: "flex flex-wrap items-start"
  }, [_c('div', {
    staticClass: "h-[32px] flex justify-between w-full items-center px-2"
  }, [_c('span', [_vm._v(_vm._s(_vm.totalText))]), _c('a', {
    staticClass: "text-[#3D7FFF]",
    on: {
      "click": _vm.clearAll
    }
  }, [_vm._v($t("jdw52", "清空"))])]), _vm._l(_vm.entityList, function (item, index) {
    return _c('div', {
      key: index,
      staticClass: "h-[22px] px-[10px] py-[5px] rounded-[6px] hover:bg-[#ebf2fa] cursor-pointer flex gap-1 items-center max-w-full flex"
    }, [_c('Icon', {
      staticClass: "text-[#3D7FFF]",
      attrs: {
        "size": "18",
        "type": item.icon
      }
    }), _c('span', {
      staticClass: "flex-1 text-ellipsis"
    }, [_vm._v(_vm._s(item.name))]), _c('Icon', {
      attrs: {
        "color": "#bdbdbd",
        "type": "md-close-circle"
      },
      on: {
        "click": function ($event) {
          return _vm.onDelete(item);
        }
      }
    })], 1);
  })], 2)])])], 1), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v($t("ev022", "取消"))]), _c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.confirm
    }
  }, [_vm._v($t("kzjg2", "确定"))])], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };